import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue'; 
import TelaSucesso from '../views/TelaSucesso.vue';
import AtualizadoSucesso from '../views/AtualizadoSucesso.vue';
import TelaFalha from '../views/Falha.vue';
import ListaComponent from '../views/ListaComponent.vue';
import AcessoNegado from '../views/AcessoNegado.vue';
import HistoricoPage from '../views/HistoricoPage.vue';


const routes = [
  {
    path: '/nova_ficha/:num_ficha?',
    name: 'Nova Ficha',
    component: HomePage
  },
  {
    path: '/editar/:num_ficha',
    name: 'Editar Ficha',
    component: HomePage
  },
  {
    path: '/falha',
    name: 'Falha',
    component: TelaFalha
  },
  {
    path: '/sucesso/:num_ficha',
    name: 'Sucesso',
    component: TelaSucesso
  },
  {
    path: '/atualizado/:num_ficha',
    name: 'AtualizadoSucesso',
    component: AtualizadoSucesso
  },
  {
    path: '/lista',
    name: 'Listagem',
    component: ListaComponent
  },
  {
    path: '/historico/:num_ficha',
    name: 'Historico',
    component: HistoricoPage
  },
  {
    path: '/acesso_negado',
    name: 'AcessoNegado',
    component: AcessoNegado
  }
  // Adicione outras rotas conforme necessário
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;